// extracted by mini-css-extract-plugin
module.exports = {"select":"CxBU07C3Lt4ydFfB9HlF"};